export default __webpack_public_path__ + "static/mission-2e2a7de29c0d9128afe51aa37874754f.png";